import { useInputPageHook } from "../hooks";
import { DisclaimerStyled } from "../styles/inputForms.styled";

const Disclaimer = () => {
  const { termDisclaimer = "", parsedTermDisclaimer = "" } = useInputPageHook();
  return (
    <DisclaimerStyled>
      {termDisclaimer ? parsedTermDisclaimer : <></>}
    </DisclaimerStyled>
  );
};

export default Disclaimer;
